import StatisticsSegment from './StatisticsSegment'
export default StatisticsSegment
